import React from 'react';
import { Breadcrumb } from 'antd';
import { useFilterPanelVisible, useResetState } from '../hooks';
import * as Styled from './styled';
import * as atoms from '../atom';
import { useAtomValue } from 'jotai';

export const Nav = () => {
  const filterPanel = useFilterPanelVisible();
  const resetAction = useResetState();
  const callbacks = useAtomValue(atoms.callbacks);

  const items = [
    {
      title: 'Filter Management',
      onClick: filterPanel.isVisible
        ? () => {
            resetAction.resetFilterClone();
            resetAction.resetFilterCreate();
            resetAction.resetFilterEditor();
            callbacks.onFilterEditorReset?.();
          }
        : undefined,
    },
    filterPanel.isFilterCreateVisible && {
      title: 'Create Filter',
    },
    filterPanel.isFilterCloneVisible && {
      title: 'Clone Filter',
    },
    filterPanel.isFilterEditorVisible && {
      title: 'Edit Filter',
    },
  ];
  return (
    <Breadcrumb separator=">">
      {items.map((it) => {
        if (!it) return null;
        return (
          <Breadcrumb.Item onClick={it.onClick} key={it.title}>
            <Styled.Title clickable={!!it.onClick}>{it.title}</Styled.Title>
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};
